import styled from 'styled-components';

export default styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(45%, 1fr));
	grid-template-rows: auto;
	gap: inherit;

	.full {
		grid-column-start: span 2;
	}

	.double-vertical {
		grid-row-start: span 2;
	}
`;
